import {
  GetContextMenuItemsParams,
  IRowNode,
  MenuItemDef,
} from 'ag-grid-community'
import { intl } from '../../../../i18n'
import {
  ContextMenuItemId,
  getMenuIconHtml,
} from '../../../containers/commons/AgGrid/lib/contextMenu'
import { TicketTypeRow } from '../TicketTypeRow'
import { focusRow } from '../../../containers/BulkSheetView/lib/gridApi'
import { createNewTicketTypeRow } from '../ticketTypeHelpers'

/**
 * 行追加メニューアイテム
 */
export const addRowMenuItems = (
  params: GetContextMenuItemsParams,
  data: TicketTypeRow[],
  setData: (d: TicketTypeRow[], r: TicketTypeRow[]) => void
): MenuItemDef[] => {
  return [
    {
      name: intl.formatMessage({
        id: 'bulksheet.contextMenu.insert.row',
      }),
      icon: getMenuIconHtml(ContextMenuItemId.ADD_ROW),
      action: () => {
        // 既存のコード一覧を取得（重複チェック用）
        const existingCodes = data.map(row => row.code).filter(Boolean)
        const newRow = createNewTicketTypeRow(existingCodes)
        const newData = [...data, newRow]
        const newRows = [newRow]
        setData(newData, newRows)
        focusRow(params.api, newRow.uuid)
      },
    },
  ]
}

/**
 * 複数行追加メニューアイテム
 */
export const addMultipleRowsMenuItem = (
  onOpenDialog: () => void
): MenuItemDef => {
  return {
    name: intl.formatMessage({
      id: 'bulksheet.contextMenu.insert.multipleRow',
    }),
    icon: getMenuIconHtml(ContextMenuItemId.ADD_MULTIPLE_ROW),
    action: onOpenDialog,
  }
}

/**
 * 行削除メニューアイテム
 */
export const deleteRowMenuItems = (
  selectedNodes: IRowNode<TicketTypeRow>[],
  action: () => void
): MenuItemDef[] => {
  // プリセット行または使用中の行が選択されているかチェック
  const hasPresetRow = selectedNodes.some(node => node.data?.isPreset)
  const hasUsedRow = selectedNodes.some(node => node.data?.isUsed)

  return [
    {
      name: intl.formatMessage(
        { id: 'bulksheet.contextMenu.delete' },
        { count: selectedNodes.length }
      ),
      icon: getMenuIconHtml(ContextMenuItemId.REMOVE_ROW),
      action,
      shortcut: intl.formatMessage({
        id: 'bulksheet.contextMenu.shortcut.row.delete',
      }),
      disabled: hasPresetRow || hasUsedRow, // プリセット行または使用中の行が含まれている場合は非活性
    },
  ]
}
